import moment from 'moment';
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import {
  GET_USER_EXPENSE_SUB,
  GET_LATEST_BUDGET_REQUEST_NOTIFICATION,
  GET_LAST_FIVE_UN_CATEGORIZED,
  GET_LAST_FIVE_BUDGET_REQUEST,
  GET_LIVETRANSACTION_GQL,
} from '@/graphql/notification.gql';

export default {
  namespaced: true,

  state: {
    notificationArray: [],
    liveTransactionList: {
      amountList: [],
      expenseDateList: [],
      marqetaTransactionIdList: [],
    },
    notificationData: {
      userName: '',
      lastName: '',
      popupType: '',
      requestDate: '',
      amount: 0,
      recordStatus: 0,
      groupName: '',
      categoryName: '',
      userRole: '',
      id: '',
      userId: '',
      categoryId: '',
      month: 0,
      year: 0,
    },
    posts: [],
  },

  mutations: {
    SET_POSTS(state, payload) {
      state.posts = payload;
    },
    SET_USER_EXPENSE(state, payload) {
      if (payload.budgetrequest) {
        const { node } = payload.budgetrequest;
        const x = {
          userName: node.user.firstName,
          lastName: node.user.lastName,
          popupType: 0,
          requestDate: node.requestDate,
          amount: node.amount,
          groupName: node.group.groupName,
          categoryName: node.category.categoryName,
          userRole: 'Admin',
          id: node.id,
          userId: node.userId,
          categoryId: node.categoryId,
          month: node.month,
          year: node.year,
        };
        state.notificationArray.push(x);
      }
      if (payload.userExpense) {
        const { node } = payload.userExpense;
        const x = {
          userName: node.Merchant.parent ? node.Merchant.parent.name : node.Merchant.name,
          popupType: 1,
          requestDate: node.expenseDate,
          amount: node.amount,
          recordStatus: node.recordStatus,
          groupName: '',
          categoryName: '',
          userRole: 'Admin',
          id: node.id,
          userId: node.userId,
          categoryId: node.categoryId,
          month: node.month,
          year: node.year,
          data: node,
          expenseDate: node.expenseDate,
          marqetaTransactionId: node.marqetaTransactionId,
        };
        state.notificationArray = [x].concat(state.notificationArray);
        const { amountList, expenseDateList, marqetaTransactionIdList } = state.liveTransactionList;

        amountList.push(x.amount);
        expenseDateList.push(moment(x.expenseDate).local().format('MM-DD-YYYY (H:mm:ss)').split(' '));
        marqetaTransactionIdList.push(x.marqetaTransactionId);
        if (amountList.length > 20) {
          amountList.shift();
          expenseDateList.shift();
          marqetaTransactionIdList.shift();
        }
        state.liveTransactionList = {
          amountList,
          expenseDateList,
          marqetaTransactionIdList,
        };

      }
    },
    SET_USER_EXPENSE_LOOP(state, payload) {
      if (payload.budgetrequests) {
        payload.budgetrequests.forEach((node) => {
          const x = {
            userName: node.user.firstName,
            lastName: node.user.lastName,
            popupType: 0,
            requestDate: node.requestDate,
            amount: node.amount,
            groupName: node.group.groupName,
            categoryName: node.category.categoryName,
            userRole: 'Admin',
            id: node.id,
            userId: node.userId,
            categoryId: node.categoryId,
            month: node.month,
            year: node.year,
          };
          state.notificationArray.push(x);
        });
      }
      if (payload.userExpenses) {
        payload.userExpenses.forEach((node) => {
          const x = {
            userName: node.Merchant.parent ? node.Merchant.parent.name : node.Merchant.name,
            popupType: 1,
            requestDate: node.expenseDate,
            amount: node.amount,
            recordStatus: node.recordStatus,
            groupName: '',
            categoryName: '',
            userRole: 'Admin',
            id: node.id,
            userId: node.userId,
            categoryId: node.categoryId,
            month: node.month,
            year: node.year,
            data: node,
          };
          state.notificationArray.push(x);
        });
      }
      state.notificationArray.sort((a, b) => a.requestDate - b.requestDate);
    },
    RESET_NOTIFICATION_ARRAY(state, _payload) {
      state.notificationArray = [];
    },
    RESET_LIVETRANSACTION_LIST(state) {
      state.liveTransactionList = {
        amountList: [],
        expenseDateList: [],
        marqetaTransactionIdList: [],
      };
    },
    SET_LIVETRANSACTION_LIST(state, payload) {
      let amountList = [];
      let expenseDateList = [];
      let marqetaTransactionIdList = [];
      payload.userExpenses.forEach((userExpense) => {
        amountList.push(userExpense.amount);
        expenseDateList.push(moment(userExpense.expenseDate).local().format('MM-DD-YYYY (H:mm:ss)').split(' '));
        marqetaTransactionIdList.push(userExpense.marqetaTransactionId);
      });
      amountList = amountList.reverse();
      expenseDateList = expenseDateList.reverse();
      marqetaTransactionIdList = marqetaTransactionIdList.reverse();
      const liveTransationListObj = {
        amountList,
        expenseDateList,
        marqetaTransactionIdList,
      };

      state.liveTransactionList = liveTransationListObj;
    },
  },

  actions: {
    // = methods
    // destructuring `context.commit` by doing `{ commit }`
    getSubUserExpenses({ commit }, payload) {
      apolloClient
        .subscribe({
          query: GET_USER_EXPENSE_SUB,
          variables: {
            recordStatus: 3,
            companyId: payload.companyId,
            user: payload.user,
          },
        })
        .subscribe({
          next(response) {
            if (response.data.userExpense.node) {
              commit('SET_USER_EXPENSE', response.data);
            }
          },
        });
    },

    getSubBudgetRequest({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .subscribe({
          query: GET_LATEST_BUDGET_REQUEST_NOTIFICATION,
          variables: {
            recordStatus: 0,
            groupId: payload.groupId,
          },
        })
        .subscribe({
          next(response) {
            console.log('response: getSubBudgetRequest', response);
            if (response.data.budgetrequest.node) {
              commit('SET_USER_EXPENSE', response.data);
            }
          },
        });
    },

    async getNotification({ commit }, payload) {
      // reset state;
      commit('RESET_NOTIFICATION_ARRAY', []);
      await apolloClient
        .query({
          query: GET_LAST_FIVE_UN_CATEGORIZED,
          variables: {
            companyId: payload.companyId,
            user: payload.user,
          },
          fetchPolicy: 'network-only',
        })
        .then(async ({ data }) => {
          // Get last five un categorized;
          commit('SET_USER_EXPENSE_LOOP', data);
          await apolloClient
            .query({
              query: GET_LAST_FIVE_BUDGET_REQUEST,
              variables: {
                ...payload,
              },
              fetchPolicy: 'network-only',
            })
            .then((data1) => {
              // Get last five un categorized;
              commit('SET_USER_EXPENSE_LOOP', data1.data);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            .catch((err) => {
              commit('shared/SET_LOADING', false, {
                root: true,
              });
              console.log(err);
            });
        })
        .catch((getNotificationerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getNotificationerr);
        });
    },
    async getLiveTransactionData({ commit }, payload) {
      commit('RESET_LIVETRANSACTION_LIST', []);
      await apolloClient
        .query({
          query: GET_LIVETRANSACTION_GQL,
          variables: {
            companyId: payload.companyId,
            user: payload.user,
          },
          fetchPolicy: 'network-only',
        })
        .then(async ({ data }) => {
          commit('SET_LIVETRANSACTION_LIST', data);
        })
        .catch((getLiveTransactionDataerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getLiveTransactionDataerr);
        });
    },
  },

  getters: {
    // = computed properties
    posts: state => state.posts,
    notificationArray: state => state.notificationArray,
    liveTransactionList: state => state.liveTransactionList,
  },
};
